var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPl10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 512 317.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FED049",
    d: "M486.24 245.71c14.87 4.62 25.76 18.55 25.76 34.88v.01c0 20.06-16.45 36.51-36.51 36.51H36.51C16.45 317.11 0 300.68 0 280.6v-.01c0-16.34 10.89-30.27 25.77-34.88 1.55-105.08 73.47-191.78 170.74-217.3l-.36-8.57C195.69 8.96 205.1 0 215.98 0h80.04c10.89 0 20.3 8.94 19.84 19.84l-.36 8.58c97.26 25.51 169.18 112.21 170.74 217.29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8AE00",
    d: "M314.67 48.28c22.75 6.37 44.18 16.1 63.41 28.6L346.75 242.2h-40.21l8.13-193.92zM205.47 242.2h-46.51L128.19 74.8c21.04-13.19 44.16-23.08 69.05-28.97l8.23 196.37z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl10);
export default __webpack_public_path__ + "static/media/pl10.135c108e21b892fce12301362b4f7043.svg";
export { ForwardRef as ReactComponent };